import React, { useContext } from 'react'
import { getReadableTextColor } from '@helpers/color_scheme_helpers'
import { markupAndSanitize, sanitize } from '@utils/sanitize'
import FormattedTime from '@components/FormattedTime'
import { ThemeContext } from '@base/ThemeContext'
import type { Timespan as TimespanType } from '@app-types/entity_types'
import type { Bounds } from '../../types/types'

type ExpandedTimespanContentProps = {
  timespan: TimespanType
  expandedItemBounds: Bounds
}

const ExpandedTimespanContent: React.FC<ExpandedTimespanContentProps> = ({ timespan, expandedItemBounds }) => {
  const colorScheme = useContext(ThemeContext)

  const bodyBackgroundColor = colorScheme.secondary
  const bodyTextColor = getReadableTextColor(bodyBackgroundColor, colorScheme)
  const headerBackgroundColor = bodyBackgroundColor
  const headerTextColor = getReadableTextColor(headerBackgroundColor, colorScheme)
  const description = timespan.description || null

  const timelineItemStyle: React.CSSProperties = {
    width: expandedItemBounds.width,
    height: expandedItemBounds.height,
    backgroundColor: bodyBackgroundColor,
    color: bodyTextColor,
  }

  const timelineItemContentStyle = {
    backgroundColor: headerBackgroundColor,
    color: headerTextColor,
  }

  return (
    <div className="timeline-item-detail" style={timelineItemStyle}>
      <div className="timeline-item-detail__content p-t p-b" style={timelineItemContentStyle}>
        <div className="timeline-item-detail__meta p-x">
          <div className="timeline-item-detail__time">
            <FormattedTime dateTime={timespan.start_date} color={headerTextColor} /> &ndash;{' '}
            <FormattedTime dateTime={timespan.end_date} color={headerTextColor} />
          </div>
          <h2 className="timeline-item-detail__title">{sanitize(timespan.title)}</h2>
        </div>
        {description && (
          <div
            className="timeline-item-detail__description block p-x"
            dangerouslySetInnerHTML={{ __html: markupAndSanitize(description) }}
          />
        )}
      </div>
    </div>
  )
}

export default ExpandedTimespanContent
